import { ReportMergeBundle, ReportGenerationArgs } from "../models/Report";
import moment from "moment";


// Against CFDI
export const FIELD_OPTIONS = [
    { label: 'Es factura global', value: 'billIsGlobal', targuet: 'binder', conditional: (b: any): string => !!b ? 'Global' : 'Normal' }, // AGAINST BINDER
    { label: 'Fecha', value: 'json.@.Fecha', targuet: 'cfdi', special: 'Date' },
    { label: 'UUID', value: 'uuid', targuet: 'cfdi' },
    { label: 'Serie', value: 'json.@.Serie', targuet: 'cfdi' },
    { label: 'Folio', value: 'json.@.Folio', targuet: 'cfdi' },
    { label: 'RFC', value: 'json.cfdi:Receptor.@.Rfc', targuet: 'cfdi' },
    { label: 'Razón social', value: 'json.cfdi:Receptor.@.Nombre', targuet: 'cfdi', conditional: (b: any): string => b.split(',').join(' ') },
    { label: 'Tipo', value: 'json.@.TipoDeComprobante', targuet: 'cfdi' },
    { label: 'Estatus', value: 'status', targuet: 'cfdi', conditional: (b: any): string => !!b ? 'Activa' : 'Cancelada' },
    { label: 'Moneda', value: 'json.@.Moneda', targuet: 'cfdi' },
    { label: 'Subtotal', value: 'json.@.SubTotal', targuet: 'cfdi', special: 'Currency' },
    { label: 'Descuento', value: 'json.@.Descuento', targuet: 'cfdi', special: 'Currency' },
    { label: 'Impuestos', value: 'json.cfdi:Impuestos.@.TotalImpuestosTrasladados', targuet: 'cfdi', special: 'Currency' },
    { label: 'Total', value: 'json.@.Total', targuet: 'cfdi', special: 'Currency' },
]

export const NOTA_CREDITO_FIELD_OPTIONS = [
    { label: 'Fecha Nota C', value: 'json.@.Fecha', targuet: 'refundCfdi', special: 'Date' },
    { label: 'UUID Nota C', value: 'uuid', targuet: 'refundCfdi' },
    { label: 'Total Nota C', value: 'json.@.Total', targuet: 'refundCfdi', special: 'Currency' },
    { label: 'Estatus Nota C', value: 'status', targuet: 'refundCfdi', conditional: (b: any): string => !!b ? 'Activa' : 'Cancelada' },
]

// AGAINST Pedido
export const PEDIDOS_FIELD_OPTIONS = [
    { label: 'ID Pedido', value: 'AmazonOrderId', targuet: 'order' },
    { label: 'Tipo de Pedido', value: 'OrderType', targuet: 'order' },
    { label: 'Es Prime', value: 'IsPrime', targuet: 'order', conditional: (b: any): string => !!b ? 'Prime' : '-' },
    { label: 'Status Pedido', value: 'OrderStatus', targuet: 'order' },
    { label: 'Fecha compra', value: 'PurchaseDate', targuet: 'order', special: 'Date' },
    { label: 'Total Pedido', value: 'OrderTotal.Amount', targuet: 'order', special: 'Currency' },
    // ====
    // { label: 'Cliente', value: 'buyer.first_name,buyer.last_name', targuet: 'order' },
]

// AGAINST Producto
export const PRODUCTOS_FIELD_OPTIONS = [
    // ITEMS
    { label: 'ASIN', value: 'ASIN', targuet: 'item' },
    { label: 'SKU', value: 'SellerSKU', targuet: 'item' },
    { label: 'Descripcion (nombre)', value: 'Title', targuet: 'item', conditional: (b: any): string => b.split(',').join(' ') },
    { label: 'Cantidad', value: 'QuantityOrdered', targuet: 'item' },
    { label: 'Precio Unitario', value: 'ItemPrice.Amount', targuet: 'item', special: 'Currency' },
    { label: 'Precio de envío', value: 'ShippingPrice.Amount', targuet: 'item', special: 'Currency' },
    // { label: 'Comisión Venta', value: 'sale_fee', targuet: 'item', special: 'Currency' },
    // ====
]

export const SHIPPING_FIELDS_OPTIONS = [
    { label: 'Tipo de envio', value: 'ShipServiceLevel', targuet: 'order', conditional: (v: any): string => v },
    // >> NONE YET 
    /*
    { label: 'Tipo de Logística', value: 'shippingArgs.logistic_type', targuet: 'order' },
    { label: 'Tracking', value: 'shippingArgs.tracking_number', targuet: 'order' },
    { label: 'Tracking Método', value: 'shippingArgs.tracking_method', targuet: 'order' },
    { label: 'Dirección de recepcion', value: 'shippingArgs.receiver_address.state,shippingArgs.receiver_address.city', targuet: 'order' },
    { label: 'Dirección de salida', value: 'shippingArgs.sender_address.state,shippingArgs.sender_address.city', targuet: 'order' },
    { label: 'Estatus de envio', value: 'shippingArgs.status', targuet: 'order' },
    { label: 'Costo Envio Vendedor', value: 'shippingArgs.shipping_sender_cost', targuet: 'order', special: 'Currency' },
    { label: 'Costo Envio Receptor', value: 'shippingArgs.shipping_receiver_cost', targuet: 'order', special: 'Currency' },
    */
]


// Level Setters
const FACTURA_LEVEL_AGGREGATORS = [
    'Es factura global',
    'UUID',
]

const PRODUCTO_LEVEL_AGGREGATORS = [
    'SKU',
    'Descripcion (nombre)',
    'Tipo de Logística'
]

const _GROUPERS_ = [
    'Cantidad',
    'Comisión Venta',
]


const flattenReportLevel = (matrix: string[][], report: ReportGenerationArgs, headers: string[]) => {
    const fieldRelators = FIELD_OPTIONS.concat(PEDIDOS_FIELD_OPTIONS, PRODUCTOS_FIELD_OPTIONS, NOTA_CREDITO_FIELD_OPTIONS, SHIPPING_FIELDS_OPTIONS);
    const columnGuides = headers.map(head => fieldRelators.find(fR => fR.label === head));
    // 1. Check if it's pedido level and return
    if (columnGuides.filter(cG => cG.label !== 'Tipo de Logística').some(cG => cG.targuet.includes('order')) || !columnGuides.some(cG => cG.label.includes('Cantidad')) || !(columnGuides.some(cG => cG.label.includes('SKU')) || columnGuides.some(cG => cG.label.includes('Descripcion (nombre)')))) {
        // If no Cantidad, there's nothing to reduce to
        return matrix;
    }
    // 2. Check if it's Factura level and merge to it
    if (columnGuides.some(cG => (cG.targuet.includes('cfdi') || cG.targuet.includes('binder')))) {
        if (columnGuides.map(cG => cG.label).some(cG => FACTURA_LEVEL_AGGREGATORS.includes(cG))) {
            const groupperIndexes = columnGuides.map(cG => cG.label).reduce((p, label, i) => {
                if (_GROUPERS_.includes(label)) {
                    p.push(i)
                }
                return p;
            }, [] as number[]);

            const aggregatorIndexes = columnGuides.map(cG => cG.label).reduce((p, label, i) => {
                if (FACTURA_LEVEL_AGGREGATORS.includes(label)) {
                    p.push(i)
                }
                return p;
            }, [] as number[]);

            const prodAggregatorIndexes = columnGuides.map(cG => cG.label).reduce((p, label, i) => {
                if (PRODUCTO_LEVEL_AGGREGATORS.includes(label)) {
                    p.push(i)
                }
                return p;
            }, [] as number[]);


            // 2.1 Dict apply to rows (column by key)
            const aggDict = matrix.reduce((p, col) => {
                const keyValues = aggregatorIndexes.map(i => col[i]).join('___');
                if (p[keyValues]) {
                    p[keyValues].push(col)
                } else {
                    p[keyValues] = [col];
                }
                return p
            }, {} as { [key: string]: string[][] });

            // Aggregator groupped Matrix
            return Object.keys(aggDict).reduce((p, uniques) => {
                const toGroupRows = aggDict[uniques];
                // 2.2 pedidos per Bill, reduce to Producto Level
                const aggProdDict = toGroupRows.reduce((p, col) => {
                    const keyValues = prodAggregatorIndexes.map(i => col[i]).join('___');
                    if (p[keyValues]) {
                        p[keyValues].push(col)
                    } else {
                        p[keyValues] = [col];
                    }
                    return p
                }, {} as { [key: string]: string[][] });

                // 2.3 Productos per Bill | BillType
                const rows = Object.keys(aggProdDict).reduce((_p, prodKey) => {
                    const prodGroupPerBill = aggProdDict[prodKey];
                    const _row = prodGroupPerBill.reduce((r, row, i) => {
                        if (i === 0) {
                            return r
                        }
                        groupperIndexes.forEach(gI => {
                            const isCurrency = row[gI].includes('$');
                            if (isCurrency) {
                                const val = parseFloat(row[gI].replace('$', ''));
                                r[gI] = `$ ${(parseFloat(r[gI].replace('$', '')) + val).toFixed(2)}`;
                            } else {
                                const val = parseFloat(row[gI]);
                                r[gI] = (parseFloat(r[gI]) + val).toFixed(2);
                            }
                        })
                        return r

                    }, prodGroupPerBill[0]);
                    _p.push(_row);
                    return _p
                }, [] as string[][])

                return p.concat(rows);
            }, [] as string[][])
        } else {
            return matrix;
        }
    }

    // 3. TODO Check if it's pewdido only level and merge to it
    // >> Continue dev by removing return below
    return matrix;
}


const toOrderRows = (mergeBundle: ReportMergeBundle[], report: ReportGenerationArgs, headers: string[]) => {
    const rows: any[] = [];
    const fieldRelators = FIELD_OPTIONS.concat(PEDIDOS_FIELD_OPTIONS, PRODUCTOS_FIELD_OPTIONS, NOTA_CREDITO_FIELD_OPTIONS, SHIPPING_FIELDS_OPTIONS);
    const columnGuides = headers.map(head => fieldRelators.find(fR => fR.label === head));
    console.log('========')
    mergeBundle.forEach((bundle) => {
        const { order, binder, cfdi, refundCfdi } = bundle;
        const column = columnGuides.reduce((p, c) => {
            if (c.targuet === 'cfdi') {
                if (!cfdi) {
                    p.push('');
                } else {

                    const accessors = c.value.split(',');
                    const colValue = accessors.reduce((value, access, i) => {
                        const properties = access.split('.');
                        const pValue = properties.reduce((o, pointed) => o[pointed], cfdi as any);
                        if (i > 0) {
                            value += ' ';
                        }
                        value += ((c.conditional ? c.conditional(pValue) : pValue) || '');
                        return value;
                    }, '');
                    if (c.special === 'Date') {
                        // >> Requires to set format options on report base top use human readable
                        // p.push(moment(new Date(colValue).getTime()).format('MMM DD YYYY HH:mm:ss'));
                        p.push(moment(new Date(colValue).getTime()).format('DD/MM/YYYY'));
                    } else if (c.special === 'Currency') {
                        p.push(`$ ${parseFloat(colValue || '0').toFixed(2)}`);
                    } else {
                        p.push(colValue);
                    }
                }
            }
            else if (c.targuet === 'refundCfdi') {
                if (!refundCfdi) {
                    p.push('');
                } else {
                    const accessors = c.value.split(',');
                    const colValue = accessors.reduce((value, access, i) => {
                        const properties = access.split('.');
                        const pValue = properties.reduce((o, pointed) => o[pointed], refundCfdi as any);
                        if (i > 0) {
                            value += ' ';
                        }
                        value += ((c.conditional ? c.conditional(pValue) : pValue) || '');
                        return value;
                    }, '');
                    if (c.special === 'Date') {
                        // >> Requires to set format options on report base top use human readable
                        // p.push(moment(new Date(colValue).getTime()).format('MMM DD YYYY HH:mm:ss'));
                        p.push(moment(new Date(colValue).getTime()).format('DD/MM/YYYY'));
                    } else if (c.special === 'Currency') {
                        p.push(`$ ${parseFloat(colValue || '0').toFixed(2)}`);
                    } else {
                        p.push(colValue);
                    }
                }
            }
            else if (c.targuet === 'order') {
                const accessors = c.value.split(',');
                const colValue = accessors.reduce((value, access, i) => {
                    const properties = access.split('.');
                    const pValue = properties.reduce((o, pointed) => !o ? null : o[pointed], order as any);
                    if (i > 0) {
                        value += ' ';
                    }
                    value += ((c.conditional ? c.conditional(pValue) : pValue) || '');
                    return value;
                }, '');
                if (c.special === 'Date') {
                    p.push(moment(new Date(colValue).getTime()).format('DD/MM/YYYY'));
                } else if (c.special === 'Currency') {
                    p.push(`$ ${parseFloat(colValue || '0').toFixed(2)}`);
                } else {
                    p.push(colValue);
                }
            } else if (c.targuet === 'binder') {
                if (!binder) {
                    p.push('')
                } else {
                    const accessors = c.value.split(',');
                    const colValue = accessors.reduce((value, access, i) => {
                        const properties = access.split('.');
                        const pValue = properties.reduce((o, pointed) => o[pointed], binder as any);
                        if (i > 0) {
                            value += ' ';
                        }
                        value += ((c.conditional ? c.conditional(pValue) : pValue) || '');
                        return value;
                    }, '');
                    if (c.special === 'Date') {
                        p.push(moment(new Date(colValue).getTime()).format('DD/MM/YYYY'));
                    } else if (c.special === 'Currency') {
                        p.push(`$ ${parseFloat(colValue || '0').toFixed(2)}`);
                    } else {
                        p.push(colValue);
                    }
                }
            }
            return p;
        }, [] as any[]);
        rows.push(column);
    });

    return flattenReportLevel(rows, report, headers) as string[][];
}

const toProductRows = (mergeBundle: ReportMergeBundle[], report: ReportGenerationArgs, headers: string[]) => {
    const rows: any[] = [];
    const fieldRelators = FIELD_OPTIONS.concat(PEDIDOS_FIELD_OPTIONS, PRODUCTOS_FIELD_OPTIONS, NOTA_CREDITO_FIELD_OPTIONS, SHIPPING_FIELDS_OPTIONS);
    const columnGuides = headers.map(head => fieldRelators.find(fR => fR.label === head));
    console.log('========')
    mergeBundle.forEach((bundle) => {
        const { order, binder, products, cfdi, refundCfdi } = bundle;
        products.forEach((item) => {
            const column = columnGuides.reduce((p, c) => {
                if (c.targuet === 'cfdi') {
                    if (!cfdi) {
                        p.push('');
                    } else {

                        const accessors = c.value.split(',');
                        const colValue = accessors.reduce((value, access, i) => {
                            const properties = access.split('.');
                            const pValue = properties.reduce((o, pointed) => o[pointed], cfdi as any);
                            if (i > 0) {
                                value += ' ';
                            }
                            value += ((c.conditional ? c.conditional(pValue) : pValue) || '');
                            return value;
                        }, '');
                        if (c.special === 'Date') {
                            // >> Requires to set format options on report base top use human readable
                            // p.push(moment(new Date(colValue).getTime()).format('MMM DD YYYY HH:mm:ss'));
                            p.push(moment(new Date(colValue).getTime()).format('DD/MM/YYYY'));
                        } else if (c.special === 'Currency') {
                            p.push(`$ ${parseFloat(colValue || '0').toFixed(2)}`);
                        } else {
                            p.push(colValue);
                        }
                    }
                }
                else if (c.targuet === 'refundCfdi') {
                    if (!refundCfdi) {
                        p.push('');
                    } else {
                        const accessors = c.value.split(',');
                        const colValue = accessors.reduce((value, access, i) => {
                            const properties = access.split('.');
                            const pValue = properties.reduce((o, pointed) => o[pointed], refundCfdi as any);
                            if (i > 0) {
                                value += ' ';
                            }
                            value += ((c.conditional ? c.conditional(pValue) : pValue) || '');
                            return value;
                        }, '');
                        if (c.special === 'Date') {
                            // >> Requires to set format options on report base top use human readable
                            // p.push(moment(new Date(colValue).getTime()).format('MMM DD YYYY HH:mm:ss'));
                            p.push(moment(new Date(colValue).getTime()).format('DD/MM/YYYY'));
                        } else if (c.special === 'Currency') {
                            p.push(`$ ${parseFloat(colValue || '0').toFixed(2)}`);
                        } else {
                            p.push(colValue);
                        }
                    }
                }
                else if (c.targuet === 'order') {
                    const accessors = c.value.split(',');
                    const colValue = accessors.reduce((value, access, i) => {
                        const properties = access.split('.');
                        const pValue = properties.reduce((o, pointed) => !o ? null : o[pointed], order as any);
                        if (i > 0) {
                            value += ' ';
                        }
                        value += ((c.conditional ? c.conditional(pValue) : pValue) || '');
                        return value;
                    }, '');
                    if (c.special === 'Date') {
                        p.push(moment(new Date(colValue).getTime()).format('DD/MM/YYYY'));
                    } else if (c.special === 'Currency') {
                        p.push(`$ ${parseFloat(colValue || '0').toFixed(2)}`);
                    } else {
                        p.push(colValue);
                    }
                } else if (c.targuet === 'item') {
                    const accessors = c.value.split(',');
                    const colValue = accessors.reduce((value, access, i) => {
                        const properties = access.split('.');
                        //console.log(`__item (${properties}) `, item);
                        const pValue = properties.reduce((o, pointed) => !o ? null : o[pointed], item as any);

                        if (c.label === 'Cantidad') {
                            if (order.OrderStatus === 'Canceled') {
                                value += '-' + ((c.conditional ? c.conditional(pValue) : pValue) || '');
                            } else {
                                value += ((c.conditional ? c.conditional(pValue) : pValue) || '');
                            }
                        } else {
                            value += ((c.conditional ? c.conditional(pValue) : pValue) || '');
                        }
                        return value;
                    }, '');
                    if (c.special === 'Date') {
                        p.push(moment(new Date(colValue).getTime()).format('DD/MM/YYYY'));
                    } else if (c.special === 'Currency') {
                        p.push(`$ ${!colValue ? '-' : parseFloat(colValue || '0').toFixed(2)}`);
                    } else {
                        p.push(colValue);
                    }
                } else if (c.targuet === 'binder') {
                    if (!binder) {
                        p.push('')
                    } else {
                        const accessors = c.value.split(',');
                        const colValue = accessors.reduce((value, access, i) => {
                            const properties = access.split('.');
                            const pValue = properties.reduce((o, pointed) => o[pointed], binder as any);
                            if (i > 0) {
                                value += ' ';
                            }
                            value += ((c.conditional ? c.conditional(pValue) : pValue) || '');
                            return value;
                        }, '');
                        if (c.special === 'Date') {
                            p.push(moment(new Date(colValue).getTime()).format('DD/MM/YYYY'));
                        } else if (c.special === 'Currency') {
                            p.push(`$ ${parseFloat(colValue || '0').toFixed(2)}`);
                        } else {
                            p.push(colValue);
                        }
                    }
                }
                return p;
            }, [] as any[]);
            rows.push(column);
        })
    });

    return flattenReportLevel(rows, report, headers) as string[][];
}

export const mergeBundleToRows = (mergeBundle: ReportMergeBundle[], report: ReportGenerationArgs, headers: string[]) => {
    const onProductLevel = report.pedidoFields.includes('SKU') || report.pedidoFields.includes('Cantidad') || report.pedidoFields.includes('Descripcion');
    if (onProductLevel) {
        return toProductRows(mergeBundle, report, headers);
    } else {
        return toOrderRows(mergeBundle, report, headers);
        // >> TODO make ToSaleRows work
        // return toSaleRows(mergeBundle, report, headers);
    }
}